<template lang="pug">
span.datetime(v-if="date") {{ data | moment(_format) }}
span.datetime(v-else-if="humanize") {{ data | duration('humanize', true) }}
span.datetime(v-else-if="calendar") {{ data | moment('calendar') }}
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "moment",
  props: {
    value: {
      default: ""
    },
    format: {
      default: ""
    },
    date: {
      type: Boolean
    },
    humanize: {
      type: Boolean
    },
    calendar: {
      type: Boolean
    },
    live: {
      type: Boolean
    }
  },

  data() {
    return {
      data: null,
      interval: null
    }
  },
  computed: {
    twelve() {
      return __.device.config("services.datetime_format") === "12"
    },
    _format() {
      if (!this.date || !this.format) return "LLL"

      let format = this.format
      if (!this.twelve) format = this.format.replace("hh", "HH").replace(" A", "")
      return format
    },
    ...mapGetters(["language"])
  },
  watch: {
    language() {
      setTimeout(() => this.$forceUpdate(), 1000)
    },
    value(nval) {
      this.data = nval
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.interval) clearInterval(this.interval)
      if (this.date && !this.value) this.data = new Date()
      else if (this.humanize && !this.value) this.data = "0"
      else if (this.calendar && !this.value) this.data = new Date()
      else this.data = this.value

      if (this.humanize && this.format === "date" && this.data !== "0") this.data = new Date(this.data) - new Date()

      if (this.live) {
        this.interval = setInterval(() => {
          if (this.humanize) this.data -= 60000
          else this.data = new Date()
        }, 60000)
      }
    }
  }
}
</script>

<style lang="scss">
span {
  text-transform: capitalize;
}
</style>
